import script from "./products1.vue?vue&type=script&setup=true&lang=ts"
export * from "./products1.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__